import SelectMenu from "../../../controls/SelectMenu";
import type {
  FinanceProductFilterOptions,
  FinanceReportFilters,
  ReportFilterOption,
  SetFinanceReportFilters,
} from "./types";

type Props = FinanceProductFilterOptions & {
  filters: FinanceReportFilters;
  setFilters: SetFinanceReportFilters;
};

export default function FinanceProductFilters({
  filters,
  setFilters,
  products,
  classes,
  categories,
}: Props) {
  const update = (key: "class" | "category" | "product", value: ReportFilterOption) =>
    setFilters({ ...filters, [key]: value });

  return (
    <>
      <SelectMenu
        title="Class"
        name="class"
        options={classes}
        value={filters.class}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("class", event.target.value)
        }
      />
      <SelectMenu
        title="Category"
        name="category"
        options={categories}
        value={filters.category}
        disabled={filters.class.value === -1}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("category", event.target.value)
        }
      />
      <SelectMenu
        title="Product"
        name="product"
        options={products}
        value={filters.product}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("product", event.target.value)
        }
      />
    </>
  );
}
